import React from "react"
import PropTypes from "prop-types"

class MeetingExchangeButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: ''
    }
    this.addToLex = this.addToLex.bind(this)
    this.removeFromLex = this.removeFromLex.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: `../check_meetings_exchanges`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId,
      },
      success: (data) => {
        if(JSON.parse(data.data.meeting_exchange).length > 0) {
          this.setState({
            text: 'Remove from Lex',
            exists: true,
          })
          return
        }
        this.setState({
          text: 'Add to Lex',
          exists: false
        })
        return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  addToLex() {
    $.ajax({
      url: `../add_meetings_exchange`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId
      },
      success: (data) => {
          this.setState({
            text: 'Remove from Lex',
            exists: true,
          })
          return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  removeFromLex() {
    $.ajax({
      url: `../remove_meetings_exchange`,
      dataType: 'JSON',
      type: 'DELETE',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId
      },
      success: (data) => {
          this.setState({
            exists: false,
          })
          return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }


    render() {
      if(this.state.exists === true) {
        return(
          <div style={{alignSelf: 'flex-end', marginTop: 24}}>
            <div onClick={() => this.removeFromLex()} style={{border: '2px solid #E57373', borderRadius: 30, cursor: 'pointer'}}>
              <h4 style={{color: '#E57373', fontWeight: 600, padding: 12}}>Remove from Lex</h4>
            </div>
          </div>
        )
      } else if (this.state.exists === false) {
        return(
          <div style={{alignSelf: 'flex-end', marginTop: 24}}>
            <div onClick={() => this.addToLex()} style={{border: '2px solid #03A9F4', borderRadius: 30, cursor: 'pointer'}}>
              <h4 style={{color: '#03A9F4', padding: 12, fontWeight: 600}}>Add to Lex</h4>
            </div>
          </div>
        )
      }
      return null

    }

}

export default MeetingExchangeButton;
